import React from 'react'
import { FundItem } from '../../../../models/Fund';
import ContentBox from '../../../common/ContentBox';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TrackRecordsList from './TrackRecordsList';
import FavoriteFundButton from '../../FavoriteFundButton';

export interface ITrackRecordsTabContentProps {
    fund: FundItem;
}

const TrackRecordsTabContent: React.FC<ITrackRecordsTabContentProps> = ({ fund }) => {
    const { t } = useTranslation();
    return <ContentBox proportion={1}>
        <Box display={"flex"} flexDirection={"column"} gap={"20px"}>
            <Box display={"flex"} justifyContent={"space-between"}>
                <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('LibraryOfFundTrackRecordsTabTitle')}</Typography>
                <FavoriteFundButton fundId={fund.id} />
            </Box>
            <TrackRecordsList trackRecords={fund.trackRecords} />
        </Box>
    </ContentBox>
}

export default TrackRecordsTabContent